<div
    [id]="id + '.' + filter.id"
    class="agpr-filterText"
>
    <agpr-filter-include-exclude
        *ngIf="filter.showIncludeExclude"
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <label
        class="agpr-filterText-search"
    >
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            [icon]="filter.showMagnifyingGlass ? 'fa-regular fa-duotone fa-magnifying-glass' : ''"
            [iconDecorative]="true"
            [ariaLabel]="filter.placeholder"
            [placeholder]="filter.placeholder"
            [(ngModel)]="searchQuery"
            (change)="search()"
            [style]="style"
        ></agpr-text-input>
        <agpr-button
            *ngIf="filter.showAddCustomButton && searchQuery"
            [id]="id + '-' + filter.id + '-addCustom'"
            label="Common.filter.checkboxes.addCustom"
            [style]="buttonStyles.tertiary"
            (click)="search()"
        ></agpr-button>
    </label>
</div>
